module.exports = __webpack_public_path__ + "img/allow-map2.b664627b.png";